import { render, staticRenderFns } from "./Sponsorenwand.vue?vue&type=template&id=bb1ddc2c&scoped=true"
import script from "./Sponsorenwand.vue?vue&type=script&lang=js"
export * from "./Sponsorenwand.vue?vue&type=script&lang=js"
import style0 from "./Sponsorenwand.vue?vue&type=style&index=0&id=bb1ddc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1ddc2c",
  null
  
)

export default component.exports